import script from "./RegistView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistView.vue?vue&type=script&setup=true&lang=js"

import "./RegistView.vue?vue&type=style&index=0&id=3ed5937f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ed5937f"]])

export default __exports__